<template>
    <v-container class="q-my-card">
        <v-overlay color="#46c3b2" :value="!hasAccessCode()" class="text-center">
            <q-access-code></q-access-code>
        </v-overlay>
        <v-row wrap v-if="hasAccessCode()">
            <v-col cols="12" sm="6">
                <h3 class="mb-4">My QuilityRx Card</h3>
                <div style="width: 500px">
                    <q-quility-rx-card bin="023518" pcn="ARX" :group-code="group_code" :id="card_id"></q-quility-rx-card>
                </div>
            </v-col>
            <v-col cols="12" sm="6">
                <h3 class="mb-4">Saved Prescriptions</h3>
                <div v-if="pharmacies.length == 0">
                    You do not have any saved prescriptions. <a href="/rx.quility-member-services/pricing-tool/">Click here</a> to use our price lookup tool.
                </div>
                <v-expansion-panels v-model="pharmacy_panel" class="pharmacy-panel">
                    <v-expansion-panel v-for="(pharmacy, index) in pharmacies" :key="index">
                        <v-expansion-panel-header :color="pharmacy_panel == index ? '#f2fbf9' : 'white'">
                            <div class="pharmacy-name">{{pharmacy.DrugName}}</div>
                            <div class="price pr-3">{{formatShortCurrency(pharmacy.Price)}}</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <p class="body-20 bold pt-4"> {{pharmacy.PharmacyName}} - {{pharmacy.Distance}}</p>
                            <v-list dense>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon color="#46c3b2" small>fas fa-prescription</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>
                                            {{pharmacy.DrugName}}<br>
                                            {{pharmacy.Quantity}} x {{pharmacy.Dosage}} {{translateForm(pharmacy.Type)}}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon color="#46c3b2" small>fas fa-map-marker-alt</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>
                                            <a :href="'https://www.google.com/maps/dir/?api=1&destination=' + pharmacy.Lat + ',' + pharmacy.Long" target="_blank">{{pharmacy.Address}}</a>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon color="#46c3b2" small>fas fa-phone</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>
                                            <a :href="'tel:' + pharmacy.PBMPhone" target="_blank">{{pharmacy.PBMPhone}}</a>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-btn right depressed text dark class="ml-3 mt-3" @click="removePharmacy(index)">
                                Remove
                            </v-btn>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import QQuilityRxCard from '@/components/q-quility-rx-card.vue'
import Cookies from 'js-cookie'
import QAccessCode from '@/components/q-access-code.vue'
var numeral = require('numeral');
export default {
    props: [],
    data: function() {
        return {
            pharmacy_panel: 0,
            pharmacies: []
        }
    },
    mounted: function() {
        var saved_pharmacies = Cookies.get('saved_pharmacies');
        if (typeof saved_pharmacies == 'undefined') {
            saved_pharmacies = []
        } else {
            saved_pharmacies = JSON.parse(Cookies.get('saved_pharmacies'));
        }
        return this.pharmacies = saved_pharmacies;
    },
    computed: {
        'group_code': function() {
            return Cookies.get('QuilityRxGroupCode')
        },
        'card_id': function() {
            return Cookies.get('QuilityRxID')
        }
    },
    methods: {
        formatShortCurrency(n) {
            return numeral(n).format('($0[.]00)');
        },
        formatPercentage(n) {
            return num
        },
        removePharmacy: function(ix) {
            this.pharmacies.splice(ix, 1);
            Cookies.set('saved_pharmacies', JSON.stringify(this.pharmacies), { path: '/' });
            this.pharmacy_panel = null
        }
    },
    watch: {

    },
    components: {
        QQuilityRxCard,
        QAccessCode
    }
}
</script>
<style>
.q-my-card .pharmacy-panel .v-expansion-panel-header {
    display: flex;
    width: 100%;
    color: #000000;
}

.q-my-card .pharmacy-panel .v-expansion-panel-header>.price {
    font-size: 18px;
    font-weight: 500;
    flex-grow: 0;
    padding-right: 5px;
}

.q-my-card .v-expansion-panel-header>.pharmacy-name {
    font-size: 18px;
    font-weight: 500;
    flex-grow: 1;
}
</style>